import {appendQueryString, getExternalRequest} from "@pg-mono/request";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import {getFetchQueryDataMonth} from "../helpers/get_fetch_query_data";
import {getTypeForFetch, PricesViewType} from "../helpers/prices_view_type";

export interface IDistrictsDataParams {
    type: PricesViewType;
    regionSlug: string;
}

interface IFetchOwnParams extends IDistrictsDataParams {
    numberOfMonthsEarlier?: number;
}

export const fetchDistrictsData = (params: IFetchOwnParams) => {
    const endpointLink = apiBigDataLink.monthDistrictTypeStats.base(bigDataApiUrl);
    const dataRange = getFetchQueryDataMonth(params.numberOfMonthsEarlier || 1);

    const link = appendQueryString(endpointLink, {
        ...dataRange,
        scenario: "rp-price-avg",
        slug_city: params.regionSlug,
        offer_type: getTypeForFetch(params.type)
    });

    return getExternalRequest({}, link, 5000);
};
import {appendQueryString, getExternalRequest} from "@pg-mono/request";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import {getFetchQueryDataMonth} from "../helpers/get_fetch_query_data";
import {getTypeForFetch, PricesViewType} from "../helpers/prices_view_type";

export interface IDistrictsDataParams {
    type: PricesViewType;
    regionSlug: string;
}

interface IFetchOwnParams extends IDistrictsDataParams {
    numberOfMonthsEarlier?: number;
}

export const fetchDistrictsData = (params: IFetchOwnParams) => {
    const endpointLink = apiBigDataLink.monthDistrictTypeStats.base(bigDataApiUrl);
    const dataRange = getFetchQueryDataMonth(params.numberOfMonthsEarlier || 1);

    const link = appendQueryString(endpointLink, {
        ...dataRange,
        scenario: "rp-price-avg",
        slug_city: params.regionSlug,
        offer_type: getTypeForFetch(params.type)
    });

    return getExternalRequest({}, link, 5000);
};
